/* eslint-disable react/no-multi-comp */
import React, { Fragment, PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {
  Cover,
  Wrapper,
  Close,
  Hide,
  Icon,
  Body,
  HeaderWrapper,
  HeaderTitle
} from './modal.styles';

// TODO: Figure out how to capture onKeyDown only for the modal, and not all of them.
// TODO: How to capture/trap tab/focus
// TODO: Fix this damn modal mess!

class ModalPortal extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    scrollLock: PropTypes.bool.isRequired
  };

  componentDidMount() {
    const { scrollLock } = this.props;

    if (scrollLock)
      document.querySelector('html').classList.toggle('u-lock-scroll');
  }

  componentWillUnmount() {
    const { scrollLock } = this.props;

    if (scrollLock)
      document.querySelector('html').classList.toggle('u-lock-scroll');
  }

  render() {
    const { children } = this.props;

    return children;
  }
}

class Modal extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    open: PropTypes.bool,
    hideCloseButton: PropTypes.bool,
    disableEscapeKeyDown: PropTypes.bool,
    disableBackdropClick: PropTypes.bool,
    headerTitle: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
      PropTypes.node
    ]),
    scrollLock: PropTypes.bool,
    top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    bottomSpacing: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    showHeaderShadow: PropTypes.bool
  };

  static defaultProps = {
    open: false,
    hideCloseButton: false,
    disableEscapeKeyDown: false,
    disableBackdropClick: false,
    headerTitle: null,
    scrollLock: false,
    top: 0,
    bottomSpacing: '1.5rem',
    showHeaderShadow: false
  };

  modalRef = React.createRef();

  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown, true);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown, true);
  }

  onKeyDown = e => {
    const { onClose, disableEscapeKeyDown, name } = this.props;

    if (!disableEscapeKeyDown && e.key === 'Escape') onClose(name);
  };

  onClickAway = e => {
    const { onClose, name } = this.props;
    if (this.modalRef.current !== e.target) return;

    onClose(name);
  };

  render() {
    const {
      children,
      hideCloseButton,
      open,
      onClose,
      disableBackdropClick,
      name,
      headerTitle,
      scrollLock,
      top,
      bottomSpacing,
      showHeaderShadow,
      ...rest
    } = this.props;

    return (
      <Fragment>
        {open &&
          ReactDOM.createPortal(
            <ModalPortal scrollLock={scrollLock}>
              <Cover
                top={top}
                role="dialog"
                aria-modal="true"
                tabIndex="-1"
                ref={this.modalRef}
                onClick={!disableBackdropClick ? this.onClickAway : () => {}}
              >
                <Wrapper {...rest}>
                  <HeaderWrapper
                    hasHeader={!!headerTitle}
                    showHeaderShadow={showHeaderShadow}
                  >
                    {headerTitle && <HeaderTitle>{headerTitle}</HeaderTitle>}

                    {!hideCloseButton && (
                      <Close
                        aria-label="Close Modal"
                        onClick={() => onClose(name)}
                      >
                        <Hide>Close</Hide>
                        <Icon viewBox="0 0 40 40" {...rest}>
                          <path d="M 10,10 L 30,30 M 30,10 L 10,30" />
                        </Icon>
                      </Close>
                    )}
                  </HeaderWrapper>

                  <Body bottomSpacing={bottomSpacing}>{children}</Body>
                </Wrapper>
              </Cover>
            </ModalPortal>,
            document.body
          )}
      </Fragment>
    );
  }
}
export default Modal;
